import api from './axios';

export const getProductsApi        = (params)      => api.get('/products', { params });
export const getProductBySlugApi   = (slug)        => api.get(`/products/${slug}`);
export const getCategoriesApi      = ()            => api.get('/categories');

// Admin CRUD
export const createProductApi      = (data)        => api.post('/products', data);
export const updateProductApi      = (id, data)    => api.put(`/products/${id}`, data);
export const deleteProductApi      = (id)          => api.delete(`/products/${id}`);
export const uploadProductImgApi   = (id, form)    => api.post(`/products/${id}/images`, form, { headers: { 'Content-Type': undefined } });
export const updateInventoryApi    = (id, data)    => api.patch(`/products/${id}/inventory`, data);

// Variants
export const getVariantsApi          = (id)          => api.get(`/products/${id}/variants`);
export const createVariantApi        = (id, data)    => api.post(`/products/${id}/variants`, data);
export const updateVariantApi        = (id, vid, d)  => api.put(`/products/${id}/variants/${vid}`, d);
export const deleteVariantApi        = (id, vid)     => api.delete(`/products/${id}/variants/${vid}`);
export const updateVariantSchemaApi  = (id, data)    => api.patch(`/products/${id}/variant-schema`, data);
